<div class="card sessions-group mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.Sessions" | translate }}
                </h5>
            </div>

            <div class="col-md-4">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-success btn-action pull-right"
                        [disabled]="isAnyItemEdited"
                        bcClick
                        hznTestId="sessions-add"
                        (clicked)="add()"
                    >
                        {{ "General.Add" | translate }}
                    </button>
                }
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mb-2">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-action btn-danger camp-credit-points-btn"
                        [disabled]="isAnyItemEdited"
                        bcClick
                        (clicked)="changeAllowCampCreditPoints()"
                    >
                        {{
                            "CampDetails.ChangeCampCreditPointsUsageBtn"
                                | translate
                        }}
                    </button>
                }
            </div>
        </div>
        <div class="card-text" [formGroup]="form">
            <div>
                <tabset #tabset>
                    @for (
                        tabz of form.controls.items["controls"];
                        track tabz;
                        let i = $index
                    ) {
                        <tab
                            customClass="session-tab"
                            [heading]="tabz.controls.club.value"
                            (selectTab)="onSelectTab(tabz)"
                        >
                            @if (tabz.controls.active.value) {
                                <app-sessions-list
                                    [form]="tabz"
                                    [context]="context"
                                ></app-sessions-list>
                            }
                        </tab>
                    }
                </tabset>
            </div>
        </div>
    </div>
</div>
